import styled from "styled-components";

export const Container = styled.div `
    position: fixed;
    inset: 0;
    background-image: ${props=> props.background_color ? `radial-gradient(circle at center, #00000099, ${props.background_color}cc 100%)` : ''};
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;
`

export const Content = styled.div `
    display: flex;
    flex-direction: column;
    position: absolute;
    bottom: 0;
    width: 100%;
    max-width: 70dvw;
    height: 95dvh;
    max-height: 95dvh;
    background: #252525;
    padding: 20px;
    border-radius: 5px;
    overflow-y: auto;
    box-shadow: 0 0 20px 5px #00000060;

    header {
        display: flex;
    }

    header a {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #30303099;
        border: 2px solid #aaa;
        border-radius: 50%;
        padding: 10px;
        transition: all .3s ease;
    }

    header a:hover {
        border-color: #fff;
        background: #000;
    }

    .hidden-component {
        display: none;
    }

    @media (max-width: 1000px) {
        max-width: 80dvw;
    }

    @media (max-width: 800px) {
        max-width: 85dvw;
    }

    @media (max-width: 600px) {
        max-width: 95dvw;
    }
`